import { memo } from 'react'

import { Validators } from 'ui/components/Form'

import { BaseInput } from './BaseInput'
import { BaseInputProps } from './props'

type EmailProps = Omit<BaseInputProps, 'value' | 'onChange'> & {
  value?: string | unknown
  onChange?: (value: string, error?: string) => void
}

export const EmailInput = memo((props: EmailProps) => {
  return <BaseInput {...props} validator={Validators.email.valid} />
})
